import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { purchaseInvoiceViewAction } from "../../../redux/actions/purchase-action";
import CreateEditViewPurInv from "../../../components/purchase-section/purchase-invoice/create-edit-view-pur-inv";

const EditPurchaseInvoice = () => {
  const { id } = useParams();
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    dispatch(purchaseInvoiceViewAction(id, onSuccPur, onErrPur));
  }, []);

  const onSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  const [searchParams] = useSearchParams();
  const isNew = searchParams.has("new");
  return (
    <InnerLayout backBtn={true} title="Purchase Invoice Edit">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <CreateEditViewPurInv
          // <CreateEditViewPurchaseInvoice
          clickedplus={isNew}
          payto={orderDetail?.orderData?.poit_pay_to_address}
          shipto={orderDetail?.orderData?.poit_ship_to_address}
          pageType="purchase invoice"
          page="edit"
          pageName="purchase invoice"
          disabled={
            true && orderDetail?.orderData?.poit_order_status !== "draft"
          }
          orderDetail={orderDetail?.itemData}
          vendorDetails={[orderDetail?.orderData]}
        />
      )}
    </InnerLayout>
  );
};

export default EditPurchaseInvoice;
